import Image from 'next/image';
import Link from 'next/link';

import { joinSgcmMedia, joinSgcmMsSite } from '@/utils/url/join/public';

import styles from './styles.module.scss';
import type { Component } from './types';

export const ElitesLabel: Component = () => {
  const title = 'Sgcarmart’s Elites';

  return (
    <Link
      className={styles.iconElite}
      href={`${joinSgcmMsSite('new-cars/elites-dealer')}`}>
      <Image
        alt="icon elite"
        height={12}
        src={`${joinSgcmMedia('/public/new-cars/elite-icon.svg')}`}
        width={12} />
      {title}
    </Link>
  );
};
